import { gql } from '@apollo/client/core'

// Ride Queries
export const GET_RIDES = gql`
  query GetRides($userId: ID!, $dateStart: String, $dateEnd: String) {
    rides(userId: $userId, dateStart: $dateStart, dateEnd: $dateEnd) {
      id
      driverId
      status
      acceptedAt
      startedAt
      completedAt
      amount
      distance
      originAddress
      destinationAddress
      paymentType
      driverLat
      driverLng
      passengerLat
      passengerLng
      isCompleted
      isInProgress
      isCanceled
      formattedAmount
      formattedDistance
      lastUpdatedAt
    }
  }
`

export const GET_RIDE_AGGREGATES = gql`
  query GetRideAggregates($userId: ID!, $dateStart: String, $dateEnd: String) {
    rideAggregates(userId: $userId, dateStart: $dateStart, dateEnd: $dateEnd) {
      # Basic Statistics
      totalRides
      totalDrivers
      completedRides
      canceledRides
      inProgressRides

      # Financial Metrics
      totalRevenue
      averageAmount
      revenuePerRide
      distancePerRide

      # Distance & Time
      totalDistance
      averageDistance
      averageDuration

      # Performance Rates
      completionRate
      cancellationRate
      successRate
      averageRidesPerDriver

      # Formatted Values
      formattedTotalRevenue
      formattedTotalDistance
      formattedAverageAmount
      formattedAverageDistance
      formattedAverageRideTime

      # Popular Patterns
      mostPopularPaymentType
      peakHour

      # Structured Data
      paymentTypeBreakdown {
        cash
        card
        pix
        corporative
        wallet
        unknown
      }
      hourlyDistribution
      dailyStats {
        averageRidesPerDay
        peakDay
        peakDayRides
        totalDays
      }
      ridesByStatus {
        accepted
        inProgress
        completed
        canceled
        unknown
      }

      ridesPerDriver
      ridesPerDriverList {
        driverId
        totalRides
        completedRides
        canceledRides
        comissionEarnings
      }
      topDriversByRides {
        driverId
        totalRides
        completedRides
        canceledRides
        comissionEarnings
      }
      lowDriversByRides {
        driverId
        totalRides
        completedRides
        canceledRides
        comissionEarnings
      }

      # Performance Indicators
      performanceIndicators {
        isPerformingWell
        hasGoodRevenue
        hasConsistentActivity
      }

      lastUpdatedAt
    }
  }
`

export const GET_SOLICITATION_AGGREGATES = gql`
  query GetSolicitationAggregates(
    $userId: ID!
    $dateStart: String
    $dateEnd: String
  ) {
    solicitationAggregates(
      userId: $userId
      dateStart: $dateStart
      dateEnd: $dateEnd
    ) {
      # Basic Statistics
      totalSolicitations
      acceptedSolicitations
      canceledSolicitations
      refusedSolicitations

      # Performance Rates
      acceptanceRate
      cancellationRate

      # Structured Data
      paymentTypeBreakdown {
        cash
        card
        pix
        corporative
        wallet
        unknown
      }
      hourlyDistribution
      dailyStats {
        averageSolicitationsPerDay
        peakDay
        peakDaySolicitations
        totalDays
      }
      solicitationsByStatus {
        requested
        accepted
        canceled
        refused
        unknown
      }

      # Performance Indicators
      performanceIndicators {
        isPerformingWell
        hasConsistentActivity
      }

      lastUpdatedAt
    }
  }
`
